import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// Services
import { ThemeService } from './services/theme.service';
import { FeatureFlagService } from './services/feature-flag.service';
import { DataService } from './services/data.service';
import { ConfigService } from './services/config.service';

// Guards (will be implemented later)
// import { AuthGuard } from './guards/auth.guard';
// import { RoleGuard } from './guards/role.guard';

// Interceptors (will be implemented later)
// import { AuthInterceptor } from './interceptors/auth.interceptor';
// import { ErrorInterceptor } from './interceptors/error.interceptor';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    ThemeService,
    FeatureFlagService,
    DataService,
    ConfigService
    // Add other core services, guards, and interceptors here
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}